"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInputChip = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _InputChipMixin = require("../../mixins/components/InputChipMixin");
var StyledInputChip = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledInputChip",
  componentId: "c11n-8-107-0__sc-tpxe8j-0"
})(["", ""], _InputChipMixin.InputChipMixin);
exports.StyledInputChip = StyledInputChip;